import { render, staticRenderFns } from "./CheckboxGhost.vue?vue&type=template&id=2a44abe9&scoped=true&"
import script from "./CheckboxGhost.vue?vue&type=script&lang=js&"
export * from "./CheckboxGhost.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGhost.vue?vue&type=style&index=0&id=2a44abe9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44abe9",
  null
  
)

export default component.exports